<ifr-page-title pageTitle="'PROJECTTIME_OVERVIEW_PAGE_TITLE' | translate "/>
<section id="project-time-overview-widget" iflx-widget-grid-directive options="vm.jarvisOptions">
  <project-time-overview
    open-recording-screen-for-person="vm.openRecordingScreenForPerson"
    activity-right="vm.activityRight"
    is-simple-user="vm.isSimpleUser"
  />
  
  <iflx-scroll-up-directive></iflx-scroll-up-directive>
</section>